// Real NBA team brand color pairs, keyed by full team name as returned
// by the vendor (`/standings`, `/teams` — e.g. "Boston Celtics"). Used
// to render two-tone diagonal-split circle swatches in place of team
// logos (no crest imagery anywhere in the app — licensing risk).
export const NBA_TEAM_COLORS = {
    // Atlantic
    "Boston Celtics": ["#007A33", "#BA9653"],
    "Brooklyn Nets": ["#000000", "#FFFFFF"],
    "New York Knicks": ["#006BB6", "#F58426"],
    "Philadelphia 76ers": ["#006BB6", "#ED174C"],
    "Toronto Raptors": ["#CE1141", "#000000"],
    // Central
    "Chicago Bulls": ["#CE1141", "#000000"],
    "Cleveland Cavaliers": ["#6F263D", "#FFB81C"],
    "Detroit Pistons": ["#C8102E", "#1D42BA"],
    "Indiana Pacers": ["#002D62", "#FDBB30"],
    "Milwaukee Bucks": ["#00471B", "#EEE1C6"],
    // Southeast
    "Atlanta Hawks": ["#E03A3E", "#C1D32F"],
    "Charlotte Hornets": ["#1D1160", "#00788C"],
    "Miami Heat": ["#98002E", "#F9A01B"],
    "Orlando Magic": ["#0077C0", "#C4CED4"],
    "Washington Wizards": ["#002B5C", "#E31837"],
    // Northwest
    "Denver Nuggets": ["#0E2240", "#FEC524"],
    "Minnesota Timberwolves": ["#0C2340", "#236192"],
    "Oklahoma City Thunder": ["#007AC1", "#EF3B24"],
    "Portland Trail Blazers": ["#E03A3E", "#000000"],
    "Utah Jazz": ["#002B5C", "#F9A01B"],
    // Pacific
    "Golden State Warriors": ["#1D428A", "#FFC72C"],
    "LA Clippers": ["#C8102E", "#1D428A"],
    "Los Angeles Clippers": ["#C8102E", "#1D428A"],
    "Los Angeles Lakers": ["#552583", "#FDB927"],
    "Phoenix Suns": ["#1D1160", "#E56020"],
    "Sacramento Kings": ["#5A2D81", "#63727A"],
    // Southwest
    "Dallas Mavericks": ["#00538C", "#B8C4CA"],
    "Houston Rockets": ["#CE1141", "#000000"],
    "Memphis Grizzlies": ["#5D76A9", "#F5B112"],
    "New Orleans Pelicans": ["#0C2340", "#C8102E"],
    "San Antonio Spurs": ["#C4CED4", "#000000"],
};

function hashColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
        hash = (hash * 31 + name.charCodeAt(i)) % 360;
    }
    return `hsl(${hash}, 55%, 38%)`;
}

// Returns [primary, secondary] — real brand pair when known, otherwise
// a deterministic single-hue fallback so unmapped names still render.
export function nbaTeamColorPair(name) {
    return NBA_TEAM_COLORS[name] || [hashColor(name), hashColor(name)];
}
